import {Link} from "react-router-dom";
import Info from "../../features/home/Info";

const logo = `${process.env.PUBLIC_URL}/assets/Logo.png`;

function Header({currentUser, isLoggingOut, onContactClick, onLogout}) {
    return (
        <>
            <header className="topbar">
                <div className="header-left">
                    <Link className="logo-link" to="/" aria-label="На главную">
                        <img className="logo" src={logo} alt="Логотип"/>
                    </Link>

                    <Link className="brand" to="/">
                        Трак-Центр 24
                    </Link>

                    <nav>
                        <ul className="nav-list">
                            <li>
                                <Link className="nav-link" to="/">Главная</Link>
                            </li>
                            {currentUser?.role === "ADMIN" && (
                                <li>
                                    <Link className="nav-link" to="/admin">Админка</Link>
                                </li>
                            )}
                        </ul>
                    </nav>
                </div>

                <div className="header-actions">
                    <Info/>
                    <button
                        className="nav-link contact-main-btn"
                        id="open-contacts"
                        type="button"
                        onClick={onContactClick}
                    >
                        Контакты
                    </button>

                    {currentUser ? (
                        <>
                            <Link className="nav-link account-main-btn" to="/account">
                                Кабинет
                            </Link>
                            <button
                                className="nav-link login-main-btn"
                                type="button"
                                disabled={isLoggingOut}
                                onClick={onLogout}
                            >
                                Выйти
                            </button>
                        </>
                    ) : (
                        <Link className="nav-link login-main-btn" to="/login">
                            Войти
                        </Link>
                    )}
                </div>
            </header>

            <div className="thin-line"/>
        </>
    );
}

export default Header;
